<div #sessionSelector class="dialog">
  <div class="title">
    <h4>Select a session</h4>
  </div>
  <!--Valid sessions-->
  @for (session of sessions; track session.id) {
    <p class="full-width-split-button-container">
      <p-split-button
        [appendTo]="sessionSelector"
        severity="primary"
        (onClick)="onSessionSelect(session.id)"
        outlined
        [model]="dropDownMenuContent.get(session.id)"
        [label]="session.sessionInfo.username"
      >
      </p-split-button>
    </p>
  }

  <p-divider />

  <p-button icon="pi pi-plus" (onClick)="router.navigate(['session', 'signin'])" label="New session"></p-button>

  <p-divider />

  <p-button link label="Home" (onClick)="router.navigate([''])"></p-button>
</div>
